export default class ConfigModel {
    api
    constructor() {
        this.api = "https://admin.stogoworld.com/api/"
        // this.api = "http://localhost:9000/api/"
        this.couponURL = "https://verify.stogoworld.com"
    }
}
